/* Fractel size guide — cm/in toggle shared by every size guide on the page and the Find Your Fit page. */
(function () {
  if (window.__fractelSizeGuide) return;
  window.__fractelSizeGuide = true;

  var KEY = 'fractel-fyf-unit';

  function saved() {
    try { var s = window.localStorage.getItem(KEY); if (s === 'cm' || s === 'in') return s; } catch (e) {}
    return null;
  }
  function fmt(cm, unit) {
    var v = unit === 'in' ? cm / 2.54 : cm;
    return String(Math.round(v * 10) / 10);
  }
  function apply(root, unit) {
    root.querySelectorAll('[data-cm]').forEach(function (el) {
      var v = parseFloat(el.getAttribute('data-cm'));
      if (!isNaN(v)) el.textContent = fmt(v, unit);
    });
    root.querySelectorAll('[data-fsg-unit-label]').forEach(function (el) { el.textContent = unit; });
    root.querySelectorAll('[data-fsg-unit]').forEach(function (b) {
      b.setAttribute('aria-pressed', b.getAttribute('data-fsg-unit') === unit ? 'true' : 'false');
    });
  }
  function applyAll(unit) {
    document.querySelectorAll('[data-fsg]').forEach(function (r) { apply(r, unit); });
  }
  function init() {
    var s = saved();
    document.querySelectorAll('[data-fsg]').forEach(function (r) {
      apply(r, s || r.getAttribute('data-default-unit') || 'cm');
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-fsg-unit]');
    if (!btn) return;
    e.preventDefault();
    var unit = btn.getAttribute('data-fsg-unit');
    try { window.localStorage.setItem(KEY, unit); } catch (err) {}
    applyAll(unit);
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
